module.exports = __webpack_public_path__ + "img/olpmc.9fee3a8c.svg";